import { render, staticRenderFns } from "./studentsEditDataFamily.vue?vue&type=template&id=0fb1676c&scoped=true"
import script from "./studentsEditDataFamily.vue?vue&type=script&lang=js"
export * from "./studentsEditDataFamily.vue?vue&type=script&lang=js"
import style0 from "./studentsEditDataFamily.vue?vue&type=style&index=0&id=0fb1676c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb1676c",
  null
  
)

export default component.exports